/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTestimonialContentAddPost } from '../fn/testimonial-content/api-master-testimonial-content-add-post';
import { ApiMasterTestimonialContentAddPost$Params } from '../fn/testimonial-content/api-master-testimonial-content-add-post';
import { apiMasterTestimonialContentDeleteGet } from '../fn/testimonial-content/api-master-testimonial-content-delete-get';
import { ApiMasterTestimonialContentDeleteGet$Params } from '../fn/testimonial-content/api-master-testimonial-content-delete-get';
import { apiMasterTestimonialContentEditPost } from '../fn/testimonial-content/api-master-testimonial-content-edit-post';
import { ApiMasterTestimonialContentEditPost$Params } from '../fn/testimonial-content/api-master-testimonial-content-edit-post';
import { apiMasterTestimonialContentGetActiveGet } from '../fn/testimonial-content/api-master-testimonial-content-get-active-get';
import { ApiMasterTestimonialContentGetActiveGet$Params } from '../fn/testimonial-content/api-master-testimonial-content-get-active-get';
import { apiMasterTestimonialContentGetAllGet } from '../fn/testimonial-content/api-master-testimonial-content-get-all-get';
import { ApiMasterTestimonialContentGetAllGet$Params } from '../fn/testimonial-content/api-master-testimonial-content-get-all-get';
import { apiMasterTestimonialContentGetByCriteriaPost } from '../fn/testimonial-content/api-master-testimonial-content-get-by-criteria-post';
import { ApiMasterTestimonialContentGetByCriteriaPost$Params } from '../fn/testimonial-content/api-master-testimonial-content-get-by-criteria-post';
import { apiMasterTestimonialContentGetByIdGet } from '../fn/testimonial-content/api-master-testimonial-content-get-by-id-get';
import { ApiMasterTestimonialContentGetByIdGet$Params } from '../fn/testimonial-content/api-master-testimonial-content-get-by-id-get';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { TestimonialContent } from '../models/testimonial-content';
import { TestimonialContentApiRespModel } from '../models/testimonial-content-api-resp-model';

@Injectable({ providedIn: 'root' })
export class TestimonialContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTestimonialContentAddPost()` */
  static readonly ApiMasterTestimonialContentAddPostPath = '/api/Master/TestimonialContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentAddPost$Response(params?: ApiMasterTestimonialContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestimonialContentApiRespModel>> {
    return apiMasterTestimonialContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentAddPost(params?: ApiMasterTestimonialContentAddPost$Params, context?: HttpContext): Observable<TestimonialContentApiRespModel> {
    return this.apiMasterTestimonialContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestimonialContentApiRespModel>): TestimonialContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentEditPost()` */
  static readonly ApiMasterTestimonialContentEditPostPath = '/api/Master/TestimonialContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentEditPost$Response(params?: ApiMasterTestimonialContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestimonialContentApiRespModel>> {
    return apiMasterTestimonialContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentEditPost(params?: ApiMasterTestimonialContentEditPost$Params, context?: HttpContext): Observable<TestimonialContentApiRespModel> {
    return this.apiMasterTestimonialContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestimonialContentApiRespModel>): TestimonialContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentDeleteGet()` */
  static readonly ApiMasterTestimonialContentDeleteGetPath = '/api/Master/TestimonialContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentDeleteGet$Response(params?: ApiMasterTestimonialContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTestimonialContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentDeleteGet(params?: ApiMasterTestimonialContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTestimonialContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentGetByIdGet()` */
  static readonly ApiMasterTestimonialContentGetByIdGetPath = '/api/Master/TestimonialContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetByIdGet$Response(params?: ApiMasterTestimonialContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TestimonialContent>> {
    return apiMasterTestimonialContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetByIdGet(params?: ApiMasterTestimonialContentGetByIdGet$Params, context?: HttpContext): Observable<TestimonialContent> {
    return this.apiMasterTestimonialContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TestimonialContent>): TestimonialContent => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentGetAllGet()` */
  static readonly ApiMasterTestimonialContentGetAllGetPath = '/api/Master/TestimonialContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetAllGet$Response(params?: ApiMasterTestimonialContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
    return apiMasterTestimonialContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetAllGet(params?: ApiMasterTestimonialContentGetAllGet$Params, context?: HttpContext): Observable<Array<TestimonialContent>> {
    return this.apiMasterTestimonialContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TestimonialContent>>): Array<TestimonialContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentGetActiveGet()` */
  static readonly ApiMasterTestimonialContentGetActiveGetPath = '/api/Master/TestimonialContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetActiveGet$Response(params?: ApiMasterTestimonialContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
    return apiMasterTestimonialContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTestimonialContentGetActiveGet(params?: ApiMasterTestimonialContentGetActiveGet$Params, context?: HttpContext): Observable<Array<TestimonialContent>> {
    return this.apiMasterTestimonialContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TestimonialContent>>): Array<TestimonialContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTestimonialContentGetByCriteriaPost()` */
  static readonly ApiMasterTestimonialContentGetByCriteriaPostPath = '/api/Master/TestimonialContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTestimonialContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentGetByCriteriaPost$Response(params?: ApiMasterTestimonialContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
    return apiMasterTestimonialContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTestimonialContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTestimonialContentGetByCriteriaPost(params?: ApiMasterTestimonialContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<TestimonialContent>> {
    return this.apiMasterTestimonialContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TestimonialContent>>): Array<TestimonialContent> => r.body)
    );
  }

}
